"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.usePaymentStatusHookFactory = void 0;
var react_1 = require("react");
var domain_1 = require("@genoa/domain");
function getUpcomingPayment(payments) {
    return payments
        .filter(function (payment) { return payment.status === domain_1.PaymentStatusV2.SCHEDULED; })
        .sort(function (a, b) { return new Date(a.due_date).getTime() - new Date(b.due_date).getTime(); })
        .shift();
}
function usePaymentStatusHookFactory(useQueryHook, useAuthStateHook, enabled, history, overrideBillAmount, generalizedSchedule, isOverwriteRepaymentDate, isUseLatestBillerAccountId, isEnableOverlimitPreview) {
    var _a;
    var _b = useAuthStateHook(), uid = _b.uid, isAnonymous = _b.isAnonymous;
    var query = useQueryHook({
        customerId: uid,
        history: history || false,
        overrideBillAmount: overrideBillAmount,
        generalizedSchedule: generalizedSchedule,
        isOverwriteRepaymentDate: isOverwriteRepaymentDate,
        isUseLatestBillerAccountId: isUseLatestBillerAccountId,
        isEnableOverlimitPreview: isEnableOverlimitPreview
    }, { skip: !uid || isAnonymous || !enabled });
    var data = (_a = query.data) === null || _a === void 0 ? void 0 : _a.data;
    var deposit = (0, react_1.useMemo)(function () {
        return data === null || data === void 0 ? void 0 : data.find(function (payment) { return payment.category === domain_1.PaymentCategoryV2.DEPOSIT; });
    }, [data]);
    var downPayment = (0, react_1.useMemo)(function () {
        return data === null || data === void 0 ? void 0 : data.find(function (payment) { return payment.category === domain_1.PaymentCategoryV2.DOWN_PAYMENT; });
    }, [data]);
    var repayments = (0, react_1.useMemo)(function () {
        return data === null || data === void 0 ? void 0 : data.filter(function (payment) { return payment.category === domain_1.PaymentCategoryV2.REPAYMENT; });
    }, [data]);
    var membershipFee = (0, react_1.useMemo)(function () {
        return data === null || data === void 0 ? void 0 : data.find(function (payment) { return payment.category === domain_1.PaymentCategoryV2.MMF; });
    }, [data]);
    var upcomingPayment = (0, react_1.useMemo)(function () {
        return data && getUpcomingPayment(data);
    }, [data, getUpcomingPayment]);
    return __assign(__assign({}, query), { isPaymentStatusLoaded: query.isError || query.isSuccess, deposit: deposit, downPayment: downPayment, repayments: repayments, membershipFee: membershipFee, upcomingPayment: upcomingPayment, payments: data });
}
exports.usePaymentStatusHookFactory = usePaymentStatusHookFactory;
